import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Button, Card, Col, DatePicker, Form, Input, message, Modal, Popconfirm, Row, Select, Table } from 'antd';
import ActiveToggle from './active-toggle';

import { 
	_activatePromo,
	_deActivatePromo, deActivatePromo,
	_getPromotions,
	addPromoToList,
	setPromotions
} from './actions';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const { Option } = Select;


class PaymentPromo extends React.Component{

	// render a table
	// add promo by clicking on plus button
	render(){

		const { loading } = this.props.paymentPromo.loading; 
		const { getFieldDecorator } = this.props.form;
		const size = "default"
		const dataSource = this.props.paymentPromo.data.sort( ( a,b ) => {
			return new Date(b.startDate) - new Date(a.startDate);
		});

		const columns = [
			{
				title: '#',
				key: 'name',
				render: (text, record, index) => {
					return index + 1;
				}
			},

			{
				title: "Start",
				dataIndex: 'startDate',
				render: ( text ) => ( moment(text).format('DD/MM/YYYY') )
			},

			{
				title: "End",
				dataIndex: 'endDate',
				render: ( text ) => ( moment(text).format('DD/MM/YYYY') )
			},

			{
				title: "Description",
				dataIndex: 'description'
			},

			{
				title: "Discount Type",
				dataIndex: "discountType"
			},

			{
				title: "Discount Amount",
				dataIndex: "discountAmount"
			},

			{
				title: "Payment Type",
				dataIndex: 'paymentMethod'
			},

			{
				title: "Actions",
				key:'actions',
				render: (text, record, index) => {
					return (
						<ActiveToggle deActivatePromo={ () => this.asyncDeactivatePromo(record) } active={record.active}/>
					)
				}
			},
		]

		return (
			<Card
				title={
					<Row type="flex" justify="space-between">
						<Col>
							<span>Payment Method Promotions</span>
						</Col>

						<Col>
							<Button onClick={this.handleOpenModal} shape="circle" icon="plus"/>
						</Col>
					</Row>
				}
				>

				<Table 
					loading={loading}
					dataSource={dataSource} 
					columns={columns} 
				/>

				<Modal
					title="Add new payment promo"
					visible={this.state.openModal}
					onOk={this.handleAddPromotion}
					onCancel={this.handleCancelModal}						
					footer={
						<Row gutter={8} type="flex" justify="end">
							<Col>
								<Button onClick={this.handleCancelModal} >Cancel</Button>
							</Col>
							<Col>
								<Popconfirm 
									title="Have you double checked all details?" 
									onConfirm={this.handleDoubleCheckedDetails} 
									onCancel={() => {}} 
									okText="Yes" 
									cancelText="No">
									
									<Button type="primary">Confirm</Button>

								</Popconfirm>
							</Col>
						</Row>
					}
				>

					<Form>
						<FormItem
							label="Date">

							{getFieldDecorator('startEndDate', {
								rules: [{ type: 'array', required: true, message: 'Please select date range!' }],
							})( <RangePicker showTime format={'DD/MM/YYYY'} size={size} /> )}

						</FormItem>

						<FormItem
							label="Description">
						
							{getFieldDecorator('description', {
								rules: [{ type: "string", required: true, message: "Please include a description!"}]
							})( <Input placeholder={"Xfers 3% OFF"} size={size} /> )}
						</FormItem>

						<FormItem
							label="Payment Method">
						
							{getFieldDecorator('paymentMethod', {
								rules: [{ type: "string", required: true, message: "Please choose a payment method!"}]
							})(
								<Select
									size={size}
									placeholder="Select a Payment Method"
								>
									<Option value="transfer">Xfers Transfer</Option>
									<Option value="card">Credit Card</Option>
									<Option value="paypal">paypal</Option>
								</Select>
							)}
						</FormItem>

						<FormItem
							label="Discount"
							gutter={8}>

							<Col span={11}>
								<FormItem>
									{getFieldDecorator('discountType', {
										rules: [{ type: "string", required: true, message: "Please choose a payment method!"}]
									})(
										<Select
											size={size}
											placeholder="Select a Discount Type (% or $)"
										>
											<Option value="percentage">Percentage (%)</Option>
											<Option value="dollars">Dollars ($)</Option>
										</Select>
									)}
								</FormItem>
							</Col>

							<Col span={2} />

							<Col span={11}>
								{getFieldDecorator('discountAmount', {
									rules: [{ required: true, message: "Please indicate how much to discount!"}]
								})(
									<Input size={size} placeholder={"Amount"} />
								)}
							</Col>
						</FormItem>

					</Form>

				</Modal>
				
			</Card>
		)
	}

	state = {
		loading:true,
		openModal: false
	}

	constructor( props ){

		super(props);

		_getPromotions()
			.then( res => {

				this.props.setPromotions(res.data.promotions);
				this.setState({ loading: false })

			})
	}

	asyncDeactivatePromo = (record) => {
		_deActivatePromo(record)
			.then( res => {

				this.props.deActivatePromo(record);

			}) 
	}

	handleCancelModal = () => {
		this.setState({
			openModal: false
		})
	}

	handleDoubleCheckedDetails = () => {
		this.props.form.validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }

			// Should format date value before submit.
			const startDate = fieldsValue['startEndDate'][0].format(),
						endDate = fieldsValue['startEndDate'][1].format(),
						paymentMethod = fieldsValue['paymentMethod'],
						description = fieldsValue['description'],
						discountType = fieldsValue['discountType'],
						discountAmount = fieldsValue['discountAmount'];

      const values = {
        startDate,
				endDate,
				paymentMethod,
				description,
				discountType,
				discountAmount
			};

			message.loading(`Activating ${description}`,0);

			_activatePromo(values)
				.then( res => {

					if(res.data.success){
						message.destroy();
						message.success(`Activated ${description}`);
						this.props.addPromoToList(res.data.promotion)
						this.props.form.resetFields();
						this.setState({ openModal: false });
					} else {
						message.destroy();
						message.error('Error!');

						console.log(res);

					}

				})
				.catch( err => {
					console.log(err.response);
					message.destroy();
					message.error( err.response.data.err.message );
				})
			
		});	


	}

	handleOpenModal = () => {
		this.setState({
			openModal: true
		})
	}

}

export default connect(
	state => ({
		paymentPromo: state.paymentPromo
	}),
	dispatchEvent => ({
		addPromoToList: ( promo ) => dispatchEvent( addPromoToList( promo ) ),
		deActivatePromo: (record) =>  dispatchEvent(deActivatePromo(record)),
		setPromotions: (promos) => dispatchEvent( setPromotions( promos ) )
	})
)( 
	Form.create()(PaymentPromo)
);


// WEBPACK FOOTER //
// ./src/components/promo/payment/index.js